import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

const CustomPasswordInput = ({
  disabled = false,
  label,
  name,
  placeholder,
  required = false,
  value,
  onChange,
}) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="flex flex-col gap-1 relative">
      {label && (
        <label htmlFor={name} className='text-lg text-blueDarker font-normal'>
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={name}
          name={name}
          type={showPassword ? 'text' : 'password'}
          required={required}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="w-full border border-bluePale rounded-xl px-3 py-3 pr-10 text-base placeholder-blueSteel"
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-5 top-1/2 -translate-y-1/2 transform text-grayMedium hover:opacity-80"
          tabIndex={-1}
        >
          {showPassword ? <Eye size={20} strokeWidth={1.65}/> : <EyeOff size={20} strokeWidth={1.65}/>}
        </button>
      </div>
    </div>
  )
}

export default CustomPasswordInput
